import template from './mobileHeader.html';
import './mobileHeader.scss';

class MobileHeaderController {
    /*@ngInject*/ 
    constructor($scope, $window, $q, $timeout, cartService, linklists, shopUserService, userService, $uibModal, $rootScope, fpStore, dataContext) {
        this.$window = $window;
        this.$q = $q;
        this.$timeout = $timeout;
        this.cartService = cartService;
        this.enableMenu = false;
        this.linklists = linklists;
        this.shopUserService = shopUserService;
        this.userService = userService;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.fpStore = fpStore;
        this.dataContext = dataContext;

        $scope.$on('cartItemsChanged', (e, data) => {
            this.getCart();
        });
    }

    $onInit() {
        this.$q.all([
            this.getCart(),
            this.addInputEvents(),
            this._setShopUserInfo()
        ]);

        //populate navMenu
        this.navMenu = this.linklists.getLinks('mobile-menu');

        this.dataContext.voziqService.getVoziqOffers().then((offers) => {
            this.offers = offers.filter((dto) => {
                return dto.OfferType === 'Equipment Only' || dto.OfferType === 'Coupon for Equipment';
            });

            if (this.offers && this.offers.length > 0 && this.fpStore.get('VoziqOfferOpened') !== 'true') {
                this.openVoziqDealModal();
            }
        });
    }

    openVoziqDealModal() {
        let modalInstance = this.$uibModal.open({
            template: '<fp-shop-voziq-offer-modal config="config"></fp-shop-voziq-offer-modal>',
            size: 'md',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss,
                    offers: this.offers
                };
            }
        });

        modalInstance.result.then(() => {
            this.fpStore.set('VoziqOfferOpened', 'true', 'local');
        });
    }

    addInputEvents() {
        this.$window.document.body.addEventListener('focusin', (event) => {
            var tagName = event.target.tagName.toLowerCase();
            if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
                this.$timeout(() => {
                    this.inputOverlay = true;
                }, 0);
            }
        });
        this.$window.document.body.addEventListener('focusout', (event) => {
            this.$timeout(() => {
                this.inputOverlay = false;
            }, 0);
        });
    }

    goToCart() {
        this.$window.location.href = this.cartUrl;
    }

    getCart() {
        this.isLoading = true;
        this.cartService.getCart()
            .then((response) => {
                this.cart = response.data;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    _setShopUserInfo() {
        //get user information then process nav
        this.shopUserService.get().then((result) => {
                this.userService.current = result;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}

export default {
    template: template,
    bindings: {
        cartUrl: '<'
    },
    controller: MobileHeaderController
};